import { jsx } from 'react/jsx-runtime';
import { useQueryClient } from '@tanstack/react-query';
import React__default, { useRef } from 'react';
import { useFabricSocketIo } from '../useFabricSocketIo.js';
import { useInvalidateQueryExportRequests } from '../../export/queries/useInvalidateQueryExportRequests.js';
import { memberPermissionsQueryKeys } from '../../permission/queries/memberPermissionsQueryKeys.js';
import { toast } from '../../store/alerts.js';
import { SocketIOContext } from './SocketIOContext.js';

const SocketIOGeneralRoomProvider = ({ children }) => {
  const queryClient = useQueryClient();
  const { socket, isConnected } = useFabricSocketIo();
  const invalidateQueryExportRequests = useInvalidateQueryExportRequests();
  const invalidateQueryExportRequestsRef = useRef(invalidateQueryExportRequests);
  invalidateQueryExportRequestsRef.current = invalidateQueryExportRequests;
  React__default.useEffect(() => {
    socket.on("MEMBER:JOINED", (data) => {
      queryClient.invalidateQueries({
        queryKey: memberPermissionsQueryKeys.byResourceId(data.spaceId)
      });
    });
    socket.on("MEMBER:LEFT", (data) => {
      queryClient.invalidateQueries({
        queryKey: memberPermissionsQueryKeys.byResourceId(data.spaceId)
      });
    });
    socket.on("OPERATION:FAILED", (data) => {
      toast({
        id: "operation-failed-socket",
        content: data.error
      });
    });
    const notifiedAsEmailDownload = [];
    socket.on("RESOURCE:EXPORT:UPDATE", (data) => {
      if (data.shouldSendEmail && !notifiedAsEmailDownload.includes(data.exportRequestId) && !data.entireAppExport) {
        notifiedAsEmailDownload.push(data.exportRequestId);
        toast({
          id: "data-export",
          replace: true,
          content: "Preparing your data. We'll email you when it's ready."
        });
      }
      if (data.status === "SUCCESS") {
        invalidateQueryExportRequestsRef.current();
        if (data.shouldSendEmail) {
          toast({
            id: "data-export",
            replace: true,
            content: "Exported files are ready for download. We've sent you an email with download links."
          });
        } else {
          toast({
            id: "data-export",
            replace: true,
            content: "Downloading..."
          });
          setTimeout(() => {
            for (let i = 0; i < data.downloadLinks.length; i++) {
              window.open(data.downloadLinks[i], "_blank");
            }
          }, 400);
        }
      }
    });
  }, [
    socket,
    queryClient
  ]);
  const providedValue = React__default.useMemo(() => {
    return {
      socket,
      isConnected
    };
  }, [
    socket,
    isConnected
  ]);
  return /* @__PURE__ */ jsx(SocketIOContext.Provider, {
    value: providedValue,
    children
  });
};

export { SocketIOGeneralRoomProvider };
//# sourceMappingURL=SocketIOProvider.js.map
